var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "account" },
    [
      _vm.initialized && _vm.isLoggedIn
        ? [
            _c("div", { staticClass: "divider" }, [
              _c("div", { staticClass: "divider__left" }, [
                _c("div", { staticClass: "account__left" }, [
                  _c(
                    "div",
                    { staticClass: "account__header insicht insicht--fade-up" },
                    [
                      _c("div", { staticClass: "account__header-user" }, [
                        _c(
                          "div",
                          { staticClass: "account__header-user-avatar" },
                          [_c("UserAvatar")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "account__header-user-details" },
                          [
                            _c("div", {
                              directives: [
                                {
                                  name: "sanitize",
                                  rawName: "v-sanitize",
                                  value:
                                    _vm.accountUserDetail.firstName +
                                    " " +
                                    _vm.accountUserDetail.lastName,
                                  expression:
                                    "`${accountUserDetail.firstName} ${accountUserDetail.lastName}`"
                                }
                              ],
                              staticClass: "account__header-user-name"
                            }),
                            _vm._v(" "),
                            _vm.accountClubDetail && _vm.accountClubDetail.tier
                              ? _c("div", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.accountClubDetail.tier.label,
                                      expression: "accountClubDetail.tier.label"
                                    }
                                  ],
                                  staticClass: "account__header-user-level"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.accountClubDetail && _vm.accountClubDetail.tier
                              ? _c("div", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.pointsToNextText,
                                      expression: "pointsToNextText"
                                    }
                                  ],
                                  staticClass: "account__header-user-points"
                                })
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.accountClubDetail
                        ? _c("UserPoints", {
                            attrs: {
                              points: _vm.accountClubDetail.balance || 0
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("Button", {
                            staticClass: "account__header-qrcode",
                            attrs: {
                              type: "button",
                              level: "primary",
                              text: _vm.$t("account.selforderingQR"),
                              icon: "qr-code",
                              small: "",
                              reverse: ""
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onSelforderingQR.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Button", {
                        staticClass: "account__header-logout",
                        attrs: {
                          type: "button",
                          level: "tertiary",
                          text: _vm.$t("account.logoutButton"),
                          arrow: ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onLogout.apply(null, arguments)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "nav",
                    { staticClass: "account__nav insicht insicht--fade-up" },
                    [
                      _c(
                        "ul",
                        { staticClass: "account__nav-list" },
                        [
                          _vm._l(_vm.areas, function(area, index) {
                            return [
                              area.header && !area.disabled
                                ? [
                                    _c("li", {
                                      key: index,
                                      staticClass: "account__nav-header",
                                      domProps: {
                                        innerHTML: _vm._s(area.label)
                                      }
                                    })
                                  ]
                                : !area.disabled
                                ? [
                                    _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass: "account__nav-item"
                                      },
                                      [
                                        _c("a", {
                                          ref:
                                            _vm.activeArea == area.id
                                              ? "navItemActive"
                                              : "navItem",
                                          refInFor: true,
                                          staticClass: "account__nav-item-link",
                                          class: {
                                            "account__nav-item-link--active":
                                              _vm.activeArea == area.id
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(area.label)
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.onNavClick(area)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "divider__right account__area" }, [
                _vm.activeArea == "discounts"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [
                        _c("h1", {
                          staticClass: "account__area-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("account.discountsTitle"))
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account__block" }, [
                          _c("h2", {
                            staticClass: "account__block-title",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("account.couponsTitle"))
                            }
                          }),
                          _vm._v(" "),
                          _vm.accountCoupons.length
                            ? _c(
                                "ul",
                                { staticClass: "account__coupons" },
                                _vm._l(_vm.accountCoupons, function(
                                  coupon,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: "coupon-" + index,
                                      staticClass: "account__coupon"
                                    },
                                    [
                                      _c("h3", {
                                        staticClass: "account__coupon-name",
                                        domProps: {
                                          innerHTML: _vm._s(coupon.title)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "account__coupon-info" },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "account__coupon-info-item"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "account__coupon-info-item-title",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "account.couponDiscount"
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "account__coupon-info-item-value",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.formatDiscount(
                                                      coupon.discount
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "account__coupon-info-item"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "account__coupon-info-item-title",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t("account.couponCode")
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "account__coupon-info-item-value",
                                                domProps: {
                                                  innerHTML: _vm._s(coupon.code)
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          coupon.validUntil
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "account__coupon-info-item"
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "account__coupon-info-item-title",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "account.couponExpiration"
                                                        )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "account__coupon-info-item-value",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formatDate(
                                                          coupon.validUntil
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          coupon.validity
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "account__coupon-info-item account__coupon-info-item--span"
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "account__coupon-info-item-title",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "account.couponRules"
                                                        )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "account__coupon-info-item-value account__coupon-info-item-value--break",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        coupon.validity
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("h3", {
                                staticClass: "account__block-empty",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("account.noCoupons"))
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _vm.accountUserDetail.groups &&
                        _vm.accountUserDetail.groups.length
                          ? _c("div", { staticClass: "account__block" }, [
                              _c("h2", {
                                staticClass: "account__block-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("account.groupsTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "account__groups-list" },
                                _vm._l(_vm.accountUserDetail.groups, function(
                                  group,
                                  index
                                ) {
                                  return _c("li", {
                                    key: index + "-" + group.name,
                                    staticClass: "account__groups-item",
                                    domProps: { innerHTML: _vm._s(group.name) }
                                  })
                                }),
                                0
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFeature("FEATURE_POINZ") &&
                        (_vm.hasFeature("FEATURE_POINZ_REGISTER") ||
                          _vm.accountPoinzDetail.available)
                          ? _c(
                              "div",
                              { staticClass: "account__block" },
                              [
                                _c(
                                  "h2",
                                  { staticClass: "account__block-title" },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("account.poinzTitle")
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.poinzText.faqUrl
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account__block-title-icon",
                                            attrs: {
                                              href: _vm.poinzText.faqUrl,
                                              target: "_blank"
                                            }
                                          },
                                          [_c("SVGInfo")],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$te("account.poinzMessage")
                                  ? _c("GeneralMessage", {
                                      attrs: {
                                        message: _vm.$t("account.poinzMessage"),
                                        type: "promo",
                                        stick: ""
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.accountPoinzDetail.available
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "account__poinz-info account__block-segments"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "account__block-segment account__block-segment--large"
                                          },
                                          [
                                            _vm.poinzRegisterConfirm.message
                                              ? _c("GeneralMessage", {
                                                  attrs: {
                                                    message:
                                                      _vm.poinzRegisterConfirm
                                                        .message,
                                                    type:
                                                      _vm.poinzRegisterConfirm
                                                        .type
                                                  },
                                                  on: {
                                                    close: function($event) {
                                                      _vm.poinzRegisterConfirm.message =
                                                        ""
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "account__poinz-grid"
                                              },
                                              _vm._l(
                                                _vm.accountPoinzDetail.perCard,
                                                function(n) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: "poinz-" + n,
                                                      staticClass:
                                                        "account__poinz-grid-item",
                                                      class: {
                                                        "account__poinz-grid-item--checked":
                                                          n <=
                                                          _vm.poinzCountCurrent
                                                      }
                                                    },
                                                    [
                                                      n <= _vm.poinzCountCurrent
                                                        ? _c("SVGCheckmark")
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "account__block-segment"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "account__poinz-title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("account.poinzCount", {
                                                    count:
                                                      _vm.poinzCountCurrent,
                                                    perCard:
                                                      _vm.accountPoinzDetail
                                                        .perCard
                                                  })
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.poinzResponse.message
                                              ? _c("GeneralMessage", {
                                                  attrs: {
                                                    message:
                                                      _vm.poinzResponse.message,
                                                    type:
                                                      _vm.poinzResponse.type,
                                                    stick: ""
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "account__poinz-text"
                                              },
                                              [
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "account.poinzCouponHint"
                                                      )
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.poinzCountCards
                                              ? _c("h4", {
                                                  staticClass:
                                                    "account__poinz-subtitle",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "account.poinzCountCards",
                                                        {
                                                          count:
                                                            _vm.poinzCountCards
                                                        }
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("Button", {
                                              attrs: {
                                                type: "button",
                                                level: "secondary",
                                                small: "",
                                                text: _vm.$t(
                                                  "account.poinzCouponButton"
                                                ),
                                                disabled:
                                                  _vm.loading ||
                                                  _vm.accountPoinzDetail.count <
                                                    _vm.accountPoinzDetail
                                                      .perCard
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.onPoinzRedeem.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm.hasFeature("FEATURE_POINZ_REGISTER")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "account__poinz-register account__block-segments"
                                      },
                                      [
                                        _vm.poinzText.column1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "account__block-segment"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "account__poinz-text",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.poinzText.column1
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.poinzText.column2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "account__block-segment"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "account__poinz-text",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.poinzText.column2
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "account__block-segment"
                                          },
                                          [
                                            _c("ValidationObserver", {
                                              ref: "poinzForm",
                                              staticClass:
                                                "account__poinz-form",
                                              attrs: {
                                                tag: "form",
                                                novalidate: ""
                                              },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.onPoinzSubmit.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var invalid = ref.invalid
                                                      var errors = ref.errors
                                                      return [
                                                        _vm.poinzResponse
                                                          .message
                                                          ? _c(
                                                              "GeneralMessage",
                                                              {
                                                                attrs: {
                                                                  message:
                                                                    _vm
                                                                      .poinzResponse
                                                                      .message,
                                                                  type:
                                                                    _vm
                                                                      .poinzResponse
                                                                      .type,
                                                                  stick: ""
                                                                }
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "birthday",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.date"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var invalid =
                                                                      ref.invalid
                                                                    var errors =
                                                                      ref.errors
                                                                    var validated =
                                                                      ref.validated
                                                                    return [
                                                                      _c(
                                                                        "FormInputDate",
                                                                        {
                                                                          attrs: {
                                                                            placeholder: _vm.$t(
                                                                              "forms.labels.birthday"
                                                                            ),
                                                                            label: _vm.$t(
                                                                              "forms.labels.birthday"
                                                                            ),
                                                                            initialValue:
                                                                              _vm
                                                                                .poinzForm
                                                                                .birthday,
                                                                            "min-date":
                                                                              "",
                                                                            "max-date":
                                                                              "today",
                                                                            required:
                                                                              "",
                                                                            disabled:
                                                                              _vm.loading
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .poinzForm
                                                                                .birthday,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.poinzForm,
                                                                                "birthday",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "poinzForm.birthday"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      invalid &&
                                                                      validated
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-error",
                                                                              domProps: {
                                                                                innerHTML: _vm._s(
                                                                                  errors[0]
                                                                                )
                                                                              }
                                                                            }
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "gender",
                                                              tag: "div",
                                                              customMessages: {
                                                                required: _vm.$t(
                                                                  "forms.errors.gender"
                                                                )
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var invalid =
                                                                      ref.invalid
                                                                    var errors =
                                                                      ref.errors
                                                                    var validated =
                                                                      ref.validated
                                                                    return [
                                                                      _c(
                                                                        "FormInputRadio",
                                                                        {
                                                                          attrs: {
                                                                            legend: _vm.$t(
                                                                              "forms.labels.salutation"
                                                                            ),
                                                                            name:
                                                                              "gender",
                                                                            options: [
                                                                              {
                                                                                value:
                                                                                  "m",
                                                                                label: _vm.$t(
                                                                                  "forms.labels.salutationMale"
                                                                                )
                                                                              },
                                                                              {
                                                                                value:
                                                                                  "f",
                                                                                label: _vm.$t(
                                                                                  "forms.labels.salutationFemale"
                                                                                )
                                                                              }
                                                                            ],
                                                                            disabled:
                                                                              _vm.loading
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .poinzForm
                                                                                .gender,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.poinzForm,
                                                                                "gender",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "poinzForm.gender"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      invalid &&
                                                                      validated
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-error",
                                                                              domProps: {
                                                                                innerHTML: _vm._s(
                                                                                  errors[0]
                                                                                )
                                                                              }
                                                                            }
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("Button", {
                                                          attrs: {
                                                            type: "submit",
                                                            level: "primary",
                                                            small: "",
                                                            text: _vm.$t(
                                                              "account.poinzRegisterButton"
                                                            ),
                                                            disabled:
                                                              _vm.loading
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2651830564
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeArea == "orders"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [
                        _c("h1", {
                          staticClass: "account__area-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("account.ordersTitle"))
                          }
                        }),
                        _vm._v(" "),
                        _vm.hasBasket &&
                        _vm.isLoggedIn &&
                        _vm.lastOrdersFiltered.length
                          ? _c("div", { staticClass: "account__block" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "account__last-orders last-orders-teaser"
                                },
                                [
                                  _c("SVGBag", {
                                    staticClass: "last-orders-teaser__icon"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "last-orders-teaser__content"
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "last-orders-teaser__text",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "shoplist.lastOrders.teaserText"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Button", {
                                        staticClass:
                                          "last-orders-teaser__button",
                                        attrs: {
                                          level: "tertiary",
                                          text: _vm.$t(
                                            "shoplist.lastOrders.teaserButton"
                                          ),
                                          type: "button",
                                          arrow: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onLastOrders.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "account__block account__block--flex"
                          },
                          [
                            _vm.hasFeature("FEATURE_LIVE_ORDER_STATE")
                              ? [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.liveOrderStates.length,
                                          expression: "liveOrderStates.length"
                                        }
                                      ],
                                      staticClass: "account__block--flex-small"
                                    },
                                    [
                                      _c("h2", {
                                        staticClass: "account__block-title",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("account.currentOrdersTitle")
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("LiveOrderStates")
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "account__block--flex-fill" },
                              [
                                _c("h2", {
                                  staticClass: "account__block-title",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("account.pastOrdersTitle")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _vm.lastOrders.length
                                  ? _c(
                                      "table",
                                      { staticClass: "account__orders" },
                                      [
                                        _c(
                                          "tr",
                                          {
                                            staticClass:
                                              "account__orders-header"
                                          },
                                          [
                                            _c("th", {
                                              staticClass:
                                                "account__orders-header-col",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("account.orderNumber")
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("th", {
                                              staticClass:
                                                "account__orders-header-col",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("account.orderDate")
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("th", {
                                              staticClass:
                                                "account__orders-header-col",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("account.orderTotal")
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.lastOrders, function(order) {
                                          return _c(
                                            "tr",
                                            {
                                              key: order.token,
                                              staticClass: "account__orders-row"
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "account__orders-row-col",
                                                  attrs: {
                                                    "data-header": _vm.$t(
                                                      "account.orderNumber"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("a", {
                                                    staticClass:
                                                      "account__orders-row-col-link",
                                                    attrs: {
                                                      href: order.url,
                                                      target: "_blank"
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        order.number
                                                      )
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", {
                                                staticClass:
                                                  "account__orders-row-col",
                                                attrs: {
                                                  "data-header": _vm.$t(
                                                    "account.orderDate"
                                                  )
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.formatDate(
                                                      order.checkoutCompletedAt
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("td", {
                                                staticClass:
                                                  "account__orders-row-col",
                                                attrs: {
                                                  "data-header": _vm.$t(
                                                    "account.orderTotal"
                                                  )
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$options.filters.fwgpricecent(
                                                      order.total,
                                                      "html"
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _c("h3", {
                                      staticClass: "account__block-empty",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("account.noOrders")
                                        )
                                      }
                                    })
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeArea == "reservations"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [
                        _c("h1", {
                          staticClass: "account__area-title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.reservations.title")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account__block" }, [
                          _vm.accountReservations.length
                            ? _c(
                                "ul",
                                { staticClass: "account__reservations" },
                                _vm._l(_vm.accountReservations, function(
                                  reservation
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: reservation.id,
                                      staticClass: "account__reservation"
                                    },
                                    [
                                      _c("h3", {
                                        staticClass:
                                          "account__reservation-date",
                                        class: {
                                          "account__reservation-date--canceled":
                                            reservation.canceled
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.reservationDate(reservation)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "account__reservation-restaurant",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.reservationRestaurant(
                                              reservation
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "account__reservation-people",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.reservationPeople(reservation)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      reservation.canceled
                                        ? _c("span", {
                                            staticClass:
                                              "account__reservation-status",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "account.reservations.canceled"
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      reservation.editable
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "account__reservation-buttons"
                                            },
                                            [
                                              _c("Button", {
                                                staticClass:
                                                  "account__reservation-button",
                                                attrs: {
                                                  type: "button",
                                                  title: _vm.$t(
                                                    "account.reservations.cancelButton"
                                                  ),
                                                  level: "secondary",
                                                  icon: "trash",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onReservationCancel(
                                                      reservation
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              !reservation.indining
                                                ? _c("Button", {
                                                    staticClass:
                                                      "account__reservation-button",
                                                    attrs: {
                                                      type: "button",
                                                      title: _vm.$t(
                                                        "account.reservations.editButton"
                                                      ),
                                                      level: "primary",
                                                      icon: "edit",
                                                      small: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onReservationEdit(
                                                          reservation
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("h3", {
                                staticClass: "account__block-empty",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("account.reservations.empty")
                                  )
                                }
                              })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeArea == "address"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [
                        _c("h1", {
                          staticClass: "account__area-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("account.addressTitle"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "account__block" },
                          [
                            _c("h3", {
                              staticClass: "account__block-subtitle",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.addressSubTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _vm.formattedAddress
                              ? _c("address", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.formattedAddress,
                                      expression: "formattedAddress"
                                    }
                                  ],
                                  staticClass: "account__address"
                                })
                              : _c("div", {
                                  staticClass: "account__address",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("account.noAddress")
                                    )
                                  }
                                }),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "account__edit-button",
                              attrs: {
                                type: "button",
                                level: "tertiary",
                                text: _vm.$t("account.addressEdit.edit"),
                                arrow: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onAddressEdit.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeArea == "personal"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [
                        _c("h1", {
                          staticClass: "account__area-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("account.personalTitle"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "account__block" },
                          [
                            _c("h2", {
                              staticClass: "account__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.userDetailTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("address", {
                              directives: [
                                {
                                  name: "sanitize",
                                  rawName: "v-sanitize",
                                  value: _vm.userDetailsFormatted,
                                  expression: "userDetailsFormatted"
                                }
                              ],
                              staticClass: "account__address"
                            }),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "account__edit-button",
                              attrs: {
                                type: "button",
                                level: "tertiary",
                                text: _vm.$t("account.userDetailEdit.edit"),
                                arrow: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onUserDetailEdit.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "account__block" },
                          [
                            _c("h2", {
                              staticClass: "account__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.passwordResetTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "account__block-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.passwordResetText")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "account__edit-button",
                              attrs: {
                                type: "button",
                                level: "tertiary",
                                text: _vm.$t("account.passwordResetButton"),
                                arrow: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onPasswordChange.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "account__block" },
                          [
                            _c("h2", {
                              staticClass: "account__block-title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("account.deleteTitle"))
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "account__block-text",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("account.deleteText"))
                              }
                            }),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "account__edit-button",
                              attrs: {
                                type: "button",
                                text: _vm.$t("account.deleteButton"),
                                level: "tertiary",
                                arrow: ""
                              },
                              on: { click: _vm.onDelete }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeArea == "referral"
                  ? _c(
                      "section",
                      {
                        staticClass:
                          "account__area-content insicht insicht--fade-up"
                      },
                      [_c("AccountReferral")],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ]
        : _vm.initialized && !_vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "account__wrapper insicht insicht--fade-up" },
            [
              _c(
                "div",
                { staticClass: "text-block text-block--center" },
                [
                  _c("h1", {
                    staticClass: "text-block__title",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("account.notLoggedIn.title"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-block__text" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("account.notLoggedIn.text"))
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("Button", {
                    attrs: {
                      level: "primary",
                      text: _vm.$t("account.notLoggedIn.button")
                    },
                    on: { click: _vm.onLogin }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "qrModal",
          attrs: {
            "overlay-type": "selfordering-qr",
            "html-classes": ["hide--header", "show--modal"],
            narrow: ""
          }
        },
        [
          _c("OverlaySelforderingQR", { on: { close: _vm.onAddressEditClose } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "userDetailModal",
          attrs: {
            "overlay-type": "user-detail-edit",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": ""
          },
          on: { softclose: _vm.onUserDetailEditSoftClose }
        },
        [
          _c("OverlayUserDetailEdit", {
            ref: "overlayUserDetailEdit",
            on: { close: _vm.onUserDetailEditClose }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "addressModal",
          attrs: {
            "overlay-type": "address-edit",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": ""
          },
          on: { softclose: _vm.onAddressEditSoftClose }
        },
        [
          _c("OverlayAddressEdit", {
            ref: "overlayAddressEdit",
            on: { close: _vm.onAddressEditClose }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "passwordModal",
          attrs: {
            "overlay-type": "password-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": ""
          },
          on: { softclose: _vm.onPasswordChangeSoftClose }
        },
        [
          _c(
            "div",
            { staticClass: "overlay-dialog" },
            [_c("FormPasswordReset", { ref: "passwordChange" })],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }